const initialState = {
  session: null,
  isAuthenticated: false,
  session_otp: null
}

export default (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case 'LOGIN':
      return {
        ...state,
        session: payload
      }
    case 'LOGIN_OTP':
      return {
        ...state,
        session_otp: payload
      }
    case 'LOGOUT':
      return {
        ...state,
        session: null
      }
    default:
      return state
  }
}
